import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";

export const getCampaignMessageSummary = ({
  token,
  uidCampaign,
  idCampaignMessage,
  isEmail,
  isRcs,
}) => {
  const uri = isEmail
    ? "reports/summarycampaignemail/"
    : "reports/summarycampaignmessage/";

  return httpClient(
    "POST",
    `${ApiEndpoint}${uri}`,
    {
      uidcampaign: uidCampaign,
      idcampaignmessage: idCampaignMessage,
      isRcs,
    },
    token,
  );
};

export const getCampaignMessageErrors = ({
  token,
  uidCampaign,
  idCampaignMessage,
}) => {
  return httpClient(
    "POST",
    `${ApiEndpoint}reports/errorscampaignmessage/`,
    {
      uidcampaign: uidCampaign,
      idcampaignmessage: idCampaignMessage,
    },
    token,
  );
};

export const getCampaignReport = ({
  token,
  uidCampaign,
  idCampaignMessage,
  typeReport = "replies",
}) => {
  return httpClient(
    "POST",
    `${ApiEndpoint}reports/${typeReport}campaignmessage`,
    {
      uidcampaign: uidCampaign,
      idcampaignmessage: idCampaignMessage,
    },
    token,
  );
};
